import { useEffect } from 'react';
import Seo from '@/components/Seo';
import { buildLocalBusinessSchema, buildBreadcrumbSchema, buildServiceCatalogSchema } from '@/lib/seo-schemas';
import CampaignTopBar from '@/components/sections/campaign/CampaignTopBar';
import CampaignQuickQuoteForm from '@/components/sections/campaign/CampaignQuickQuoteForm';
import CampaignHero from '@/components/sections/campaign/CampaignHero';
import CampaignActionBar from '@/components/sections/campaign/CampaignActionBar';
import CampaignWhyUs from '@/components/sections/campaign/CampaignWhyUs';
import CampaignServices from '@/components/sections/campaign/CampaignServices';
import CampaignStats from '@/components/sections/campaign/CampaignStats';
import CampaignHowItWorks from '@/components/sections/campaign/CampaignHowItWorks';
import CampaignFaq, { buildCampaignFaqSchema } from '@/components/sections/campaign/CampaignFaq';
import CampaignCTA from '@/components/sections/campaign/CampaignCTA';
import CoverageSection from '@/components/sections/CoverageSection';
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import { trackOaiPageView } from '@/lib/oaiPixel';

export default function LandlordOffer() {
  useEffect(() => {
    trackOaiPageView();
  }, []);

  // Google Ads (AW-17106266789) is configured once, site-wide, in index.html's single gtag.js loader.
  const localBusinessSchema = buildLocalBusinessSchema();
  const breadcrumbSchema = buildBreadcrumbSchema('/inventory-offer', 'Inventory Offer');
  const serviceCatalogSchema = buildServiceCatalogSchema();
  const faqSchema = buildCampaignFaqSchema();
  return (
    <>
      <Seo
        title="Landlord Inventory Reports from £120 | Daley Inventories"
        description="Detailed, photographic, time-stamped inventory reports for London landlords from £120 inc VAT. 10 years, 20,000 landlords, reports in 24–48 hours."
        canonical="https://daleyinventories.com/inventory-offer"
        jsonLd={[breadcrumbSchema, localBusinessSchema, serviceCatalogSchema, faqSchema]}
      />
      <CampaignTopBar />
      <div className="lg:hidden">
        <CampaignQuickQuoteForm />
      </div>
      <CampaignHero />
      <CampaignActionBar />
      <CampaignWhyUs />
      <CampaignServices />
      <CampaignStats />
      <CampaignHowItWorks />
      <TestimonialsSection />
      <CampaignFaq />
      <CoverageSection />
      <CampaignCTA />
    </>
  );
}